// extracted by mini-css-extract-plugin
export default {"card":"style_card__dwuiZ","text":"style_text__46tX9","button":"style_button__qr5Nf"};